import { z } from 'zod';

import ApiClient from '../../../helpers/ApiClient';
import { getCampusApiClient } from '../../../helpers/getClients';

export const AiFeatureFlagsSchema = z
  .object({
    ai_error_explanation_enabled: z.boolean().transform((val) => val),
    ai_explain_solution_enabled: z.boolean().transform((val) => val),
    ai_hints_or_incorrect_submition_enabled: z
      .boolean()
      .transform((val) => val),
  })
  .transform((data) => ({
    aiErrorExplanationEnabled: data.ai_error_explanation_enabled,
    aiExplainSolutionEnabled: data.ai_explain_solution_enabled,
    aiHintsOrIncorrectSubmitionEnabled:
      data.ai_hints_or_incorrect_submition_enabled,
  }));

export type AIFeatureFlags = z.infer<typeof AiFeatureFlagsSchema>;

export const DEFAULT_AI_FEATURE_FLAGS: AIFeatureFlags = {
  aiErrorExplanationEnabled: true,
  aiExplainSolutionEnabled: true,
  aiHintsOrIncorrectSubmitionEnabled: true,
};

export const getCourseAiFeatureFlagsAsPromise = async ({
  courseAsPromise,
}: {
  courseAsPromise: Promise<{ id: number }>;
}): Promise<AIFeatureFlags> => {
  const course = await courseAsPromise;

  return getCampusApiClient()
    .execute(ApiClient.endpoint.getCourseAiFeatureFlags(course.id))
    .toPromise()
    .then(({ body }: { body?: AIFeatureFlags }) =>
      body ? AiFeatureFlagsSchema.parse(body) : DEFAULT_AI_FEATURE_FLAGS,
    )
    .catch(() => DEFAULT_AI_FEATURE_FLAGS);
};
